import { useEffect, useState, type ReactNode } from 'react';

/** Enrutador por hash (#/contabilidad/...) para no depender de la configuración del servidor ni de otra librería. */
export function useHashPath(): string {
  const read = () => (window.location.hash.replace(/^#/, '') || '/').split('?')[0];
  const [path, setPath] = useState(read);
  useEffect(() => {
    const h = () => setPath(read());
    window.addEventListener('hashchange', h);
    return () => window.removeEventListener('hashchange', h);
  }, []);
  return path;
}

export function navigate(path: string): void {
  window.location.hash = path;
}

export function Link({ to, children, className }: { to: string; children: ReactNode; className?: string }) {
  return <a href={`#${to}`} className={className}>{children}</a>;
}

export interface RouteDef { pattern: string; render: (params: Record<string, string>) => ReactNode }

export function matchRoute(path: string, routes: RouteDef[]): ReactNode | null {
  for (const r of routes) {
    const pp = r.pattern.split('/').filter(Boolean);
    const sp = path.split('/').filter(Boolean);
    if (pp.length !== sp.length) continue;
    const params: Record<string, string> = {};
    let ok = true;
    for (let i = 0; i < pp.length; i++) {
      if (pp[i].startsWith(':')) params[pp[i].slice(1)] = decodeURIComponent(sp[i]);
      else if (pp[i] !== sp[i]) { ok = false; break; }
    }
    if (ok) return r.render(params);
  }
  return null;
}
